package com.milta.feature.route.data.remote.dto

import com.milta.feature.route.domain.entity.LoadingAddress
import kotlinx.serialization.Serializable

/** Mirrors the backend `LoadingAddressDto` (GET/POST /loading-addresses, MIL-99). */
@Serializable
data class LoadingAddressDto(
    val id: String,
    val address: String,
    val latitude: Double,
    val longitude: Double,
    val lastUsedAt: String? = null,
)

/** Request body of POST /loading-addresses (MIL-99). */
@Serializable
data class AddLoadingAddressRequest(
    val address: String,
    val latitude: Double,
    val longitude: Double,
)

fun LoadingAddressDto.toDomain() = LoadingAddress(
    id = id,
    address = address,
    latitude = latitude,
    longitude = longitude,
    lastUsedAt = lastUsedAt,
)
